import api from './api';

export function postSimulation(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulacion/simular`, data)
}

export function saveSimulationResult(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulacion`, data)
}

export function getSimulacionesByAdvisor(idAdvisor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAdvisor}/simulaciones`)
}

export function getSimulacionById(idSimulation) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulacion/${idSimulation}`)
}

export function getSimulacionByIdCredito(idCredito) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/creditos/${idCredito}/simulaciones`)
}

export function getSimulacionEdades(){
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulacion/edad`);
}

export function postGestionPoliticas(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/gestion-politicas/simular`, data)
}
